import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { GoogleLogin } from "@react-oauth/google";
import { useGoogleLogin } from "@react-oauth/google";
import FacebookLogin from "react-facebook-login";
import jwt_decode from "jwt-decode";
import classes from "./Auth.module.css";

import useUserinput from "../../hooks/user-input";
import useHttp from "../../hooks/use-http";

import Button from "../../components/ui/buttons/Button";
import Input from "../../components/form/input/Input";

import { addUser, signInUser } from "../../services/authentication";

import AuthContext from "../../store/context/auth-context";

import { User, UserBuilder } from "../../utils/UserFormat";

import Layout from "./layout/Layout";
import ToastContext from "../../store/context/toast-context";

const isNotEmpty = (value) => value.trim() !== "";
const isEmail = (value) => value.includes("@");

const LoginForm = () => {
  const [isVisible, setIsVisible] = useState(false);
  const dispatch = useDispatch();
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const toastCtx = useContext(ToastContext);

  const { sendRequest, status, data: userAuth, error } = useHttp(signInUser);
  const {
    sendRequest: addUserSendRequest,
    status: addUserStatus,
    data: addUserData,
    error: addUserError,
  } = useHttp(addUser);

  console.log("-----------login page----------------");
  useEffect(() => {
    console.log("------------------login ---------------");
    console.log(`status: ${status}`);
    if (status === "completed" && !error) {
      // const userData = User;
      const userData = new UserBuilder();
      // userData.email = userAuth.email;
      // userData.userSessionId = userAuth.idToken;
      // userData.last = userAuth.displayName;

      console.log(userAuth,"---")
      userData.id = userAuth?.userId;
      userData.username = userAuth?.name;
      userData.mobile = userAuth?.mobile;
      userData.email = userAuth?.emailId;
      userData.gender = userAuth?.gender;
      userData.first = userAuth?.firstName;
      userData.last = userAuth?.lastName;
      userData.middle = userAuth?.middleName;
      userData.dob = userAuth?.dob;

      // userData.userSessionId = userAuth.body.userSessionId;
      // if (userAuth.addressList !== null) {
      //   userData.addressList = userAuth.body.addressList;
      // }

      // authCtx.login(userAuth.idToken, userAuth.displayName, userAuth.email);
      // console.log(userAuth);
      authCtx.login(userAuth.accessToken, userData);

      // if (location.pathname === "/cart") {
      //   dispatch(uiActions.CloseAuthPop());
      // }
      // );
      navigate("/", { replace: true });
    }
    if (status === "completed" && error) {
      toastCtx.open(error);
    }
  }, [status, error, navigate, userAuth, authCtx, dispatch, location]);

  useEffect(() => {
    if (addUserStatus === "completed" && !addUserError) {
      console.log(addUserData);
      sendRequest({
        email: addUserData.body.emailId,
        pass: addUserData.body.passcode,
        returnSecureToken: true,
      });
    }
    // if (addUserStatus === "completed" && addUserError) {
    //   sendRequest({
    //     email: addUserData.body.emailId,
    //     pass: addUserData.body.passcode,
    //     returnSecureToken: true,
    //   });
    // }
  }, [addUserStatus, addUserError, addUserData]);
  const iconChangeHandler = () => {
    setIsVisible(!isVisible);
  };

  const facebookLoginHandler = (data) => {
    console.log(data);

    const splitName = data.name.split(" ");

    addUserSendRequest({
      username: splitName[0],
      firstName: splitName[0],
      lastName: splitName[1],
      middleName: splitName[2] ? splitName[2] : null,
      emailId: data.email,
      passcode: data.id,
      dob: "2023-03-02T19:49:55.000Z",
      gender: "Male",
      type: 1,
    });
  };

  const googleLoginHandler = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const response = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          },
        );

        const data = await response.json();
        console.log(data);
        console.log(tokenResponse);

        // addUserSendRequest({
        //   username: data.given_name,
        //   firstName: data.given_name,
        //   lastName: data.family_name,
        //   emailId: data.email,
        //   passcode: data.sub,
        //   dob: "2013-03-02T19:49:55.000Z",
        //   gender: "Male",
        //   type: 1,
        // });
      } catch (error) {
        console.log(error);
      }
    },
  });

  const {
    value: enteredEmail,
    hasError: emailInputHasError,
    isValid: enteredEmailIsValid,
    inputChangeHandler: emailInputChangeHandler,
    inputBlurHandler: emailInputBlurHandler,
    reset: resetEmailInput,
  } = useUserinput(isEmail);

  const {
    value: enteredPassword,
    hasError: passwordInputHasError,
    isValid: enteredPasswordIsValid,
    inputChangeHandler: passwordInputChangeHandler,
    inputBlurHandler: passwordInputBlurHandler,
    reset: resetPasswordInput,
  } = useUserinput(isNotEmpty);

  let formIsValid = false;

  if (enteredEmailIsValid && enteredPasswordIsValid) {
    formIsValid = true;
  }

  const formSubmitHandler = (event) => {
    event.preventDefault();

    if (!formIsValid) {
      return;
    }
    // console.log("submitted");
    // console.log(enteredEmail, enteredPassword);
    sendRequest({
      email: enteredEmail,
      pass: enteredPassword,
      returnSecureToken: true,
    });

    resetPasswordInput();
    resetEmailInput();
  };

  return (
    <Layout
      title="Welcome to Muradi! Please login."
      commands="New member?"
      path="/register"
      link=" Register "
      onSubmitHandler={formSubmitHandler}
    >
      <div className={classes["auth_module"]}>
        <div className={classes["auth_modul_col1"]}>
          <Input
            id="field"
            label="Phone Number or Email"
            type="text"
            placeHolder="Please enter your Phone Number or Email"
            required={true}
            inputIcon="person-outline"
            onChange={emailInputChangeHandler}
            onBlur={emailInputBlurHandler}
            value={enteredEmail}
            onError={emailInputHasError}
            invalidMsg={"please enter your correct email or phone number"}
          />

          <Input
            id="password"
            label="Password"
            type={isVisible ? "text" : "password"}
            placeHolder="Please enter your Password"
            required={true}
            inputIcon={isVisible ? "eye-outline" : "eye-off-outline"}
            onIconChange={iconChangeHandler}
            onChange={passwordInputChangeHandler}
            onBlur={passwordInputBlurHandler}
            value={enteredPassword}
            onError={passwordInputHasError}
            invalidMsg={"please enter your password"}
          />

          <div className={classes["forgot_psw"]}>
            <Link to={"/forget"}>Forgot Password?</Link>
          </div>
        </div>
        <div className={`${classes["auth_modul_col2"]} ${classes.mt}`}>
          <div className="muradi_auth_modul-btn">
            <Button
              // onClick={formSubmitHandler}
              ondisabled={!formIsValid}
              type="submit"
              className={classes["md-auth-button"]}
            >
              LOGIN
            </Button>
          </div>
          <div className="modul-auth-others">
            <div className={classes["modul-auth-others-line"]}>
              <span>Or, login with</span>
            </div>
            <div className="mod-third-party-auth-bd">
              {/* <FacebookLogin
                appId="939388030530268"
                autoLoad
                callback={responseFacebook}
                render={(renderProps) => (
                  <Button
                    // type="submit"
                    className={`${classes["md-auth-btn"]} ${classes["fb-button"]}`}
                  >
                    Facebook
                  </Button>
                )}
              /> */}
              <FacebookLogin
                appId="939388030530268"
                autoLoad={false}
                fields="name,email,picture"
                callback={facebookLoginHandler}
                textButton="Facebook"
                cssClass={`${classes["md-auth-btn"]} ${classes["fb-button"]}`}
                // icon="fa-facebook"
              />
              <Button
                onClick={googleLoginHandler}
                className={`${classes["md-auth-btn"]} ${classes["google-button"]}`}
              >
                Google
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default LoginForm;
